import React, { useEffect } from "react";
import { Input, Modal } from "antd";
import { useFormik } from "formik";
import { createBrickCollection } from "../../utils";
import useOrganization from "../../hooks/useOrganization";

interface Props {
  open: boolean;
  onClose(): void;
}

const CreateCollectionModal: React.FC<Props> = ({ open, onClose }) => {
  const organization = useOrganization();
  const formik = useFormik({
    initialValues: {
      name: "",
    },
    onSubmit: async (values) => {
      await createBrickCollection(organization, values);
      onClose();
    },
  });

  useEffect(() => {
    formik.resetForm();
  }, [open]);

  return (
    <Modal
      title="Nieuwe Collectie"
      open={open}
      closable={false}
      onCancel={() => onClose()}
      onOk={() => formik.handleSubmit()}
      okButtonProps={{
        disabled: formik.values.name === "",
      }}
    >
      <Input
        name="name"
        placeholder="naam"
        onChange={formik.handleChange}
        value={formik.values.name}
      />
    </Modal>
  );
};

export default CreateCollectionModal;
